import React from 'react';
import './SiteHeader.css';
import { Link, NavLink } from 'react-router-dom';

const SiteHeader: React.FC = () => {
  return (
    <header className="site-header">
      <div className="container">
        <nav className="navbar navbar-expand-md navbar-light px-0">
          <div className="d-flex align-items-center gap-2">
            <img
              src="/android-chrome-192x192.png"
              alt="Todonyx Logo"
              className="site-header-logo"
            />
            <Link to="/" className="text-decoration-none">
              <h1 className="site-header-title navbar-brand mb-0 pe-3 pe-md-4">Todonyx</h1>
            </Link>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink to="/" className="nav-link">
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/products" className="nav-link">
                  Products
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/services" className="nav-link">
                  Services
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className="nav-link">
                  About
                </NavLink>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
